import React from 'react'
import { MapTo } from '@adobe/aem-react-editable-components'
import Card from '@sial/aem-cms-components/dist/Card/Card'
import { useRouter } from '@src/routes'
import { isHomePage } from '@src/utils/analytics'

const CardAdapter: React.FC<any> = (props) => {
  const router = useRouter()
  const homePage = isHomePage(router.asPath)

  return <Card {...props} isHomePage={homePage} />
}

export default MapTo('cms-commons/components/content/card')(CardAdapter)
